














































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { APP_CONFIG } from '@/config/app-config';

import { Order } from '@/models/order';

import orderServices from '@/services/order-service';
import authService from '@/services/auth-services';
import creditServices from '@/services/credit-services';

import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import RechargeModal from '@/shared/components/RechargeModal.vue';
import formatNumber from '@/shared/filters/format-number';

import { eventBus } from '@/main';
const numeral = require('numeral');

@Component({
    components: {
        ConfirmModal,
        RechargeModal,
        Loading
    }
})
export default class OrderDetailFooter extends Vue {
    private eventEmit = {
        eventCancelOrder: 'eventCancelOrder',
        eventDepositOrder: 'eventDepositOrder',
        eventReOrder: 'eventReOrder',
        eventDuplicate: 'eventDuplicate'
    };

    private actions = {
        cancel: 'cancel',
        deposit: 'deposit',
        complain: 'complain',
        reorder: 'reorder',
        duplicate: 'duplicate'
    };
    private actionSelected: any = this.actions.cancel;
    
    @Prop({default: null})
    private order!: Order;

    @Prop({default: {}})
    private customerInfo: any;

    private isConfirm = false;
    private isRecharge = false;
    private showNextConfirm = true;
    private showOtherButton = false;
    private isLoading = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
    
    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async onActionStatus(action: any) {
        this.actionSelected = action;
        switch(this.actionSelected) {
            case this.actions.cancel: {
                this.modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                this.showOtherButton = false;
                break;
            }
            case this.actions.complain: {
                this.$router.push({ name: 'order-complain', params: { orderId: this.order.id.toString() } });
                break;
            }
            case this.actions.deposit: {
                this.modalContent = `<div style="color: #111">Số tiền bạn cần đặt cọc là <label class="fb text-danger">${ formatNumber(this.order.minDeposit, '0,0') } vnđ.</label>
                                    <div>Bạn có muốn đặt cọc không?</div></div>`;
                this.isConfirm = true;
                this.showNextConfirm = true;
                this.showOtherButton = false;
                break;
            }
            case this.actions.reorder: {
                this.modalContent = 'Bạn có thực sự muốn đặt lại đơn hàng này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                this.showOtherButton = false;
                break;
            }
            case this.actions.duplicate: {
                this.modalContent = 'Bạn có thực sự muốn đặt đơn hàng giống đơn hàng này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                this.showOtherButton = false;
                break;
            }
        }
    }

    private async onCancelOrder() {
        this.isLoading = true;
        const dataRequest =  {
            Status: 1
        };
        const result = await orderServices.updateOrder(this.order.id, dataRequest);
        
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Hủy đơn hàng thành công!',
            });
            this.$emit(this.eventEmit.eventCancelOrder, { status: 1 });
            this.isLoading = false;
        }
    }

    private async onDepositOrder() {
        if (this.customerInfo.Wallet >= this.order.minDeposit) {
            this.isLoading = true;

            const dataRequest = {
                Status: 2,
                Deposit: this.order.minDeposit
            };
            const result = await orderServices.updateOrder(this.order.id, dataRequest);
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Đặt cọc thành công!',
                });
                this.$emit(this.eventEmit.eventDepositOrder, { status: 2 });
                this.isLoading = false;

                this.getCustomersInfo();
            }
        } else {
            this.modalContent = `<div style="color: #111;">Số tiền trong ví của bạn không đủ để thanh toán.</div>
                                <div>Tiền cần cọc: <span class="fb">${formatNumber(this.order.minDeposit, '0,0')} VND</span></div>
                                <div>Ví: <span class="fb">${formatNumber(this.customerInfo.Wallet, '0,0')} VND</span></div>
                                <div>Cần nạp: <span class="fb">${formatNumber((this.order.minDeposit || 0)-this.customerInfo.Wallet, '0,0')} VND</span></div>`;
            this.isConfirm = false;
            this.showNextConfirm = false;
            this.showOtherButton = true;
            this.isRecharge = true;
        }
        
    }

    private async onReOrder() {
        this.isLoading = true;

        const dataRequest = {
            Status: 3,
            Deposit: 0
        };
        const result = await orderServices.updateOrder(this.order.id, dataRequest);
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Đặt lại đơn hàng thành công!',
            });
            this.$emit(this.eventEmit.eventReOrder, { status: 3 });
        }
        this.isLoading = false;
    }

    private async onDuplicate() {
        this.isLoading = true;

        const dataRequest = {
            'ID': this.order.id
        };
        const result = await orderServices.duplicateOrder(dataRequest);
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Đặt lại đơn hàng thành công!',
            });
            this.$emit(this.eventEmit.eventDuplicate, { status: 3 });
        }
        this.isLoading = false;
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        this.isRecharge = false;
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK' && this.actionSelected === this.actions.cancel) {
            this.onCancelOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.deposit) {
            this.onDepositOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.reorder) {
            this.onReOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.duplicate) {
            this.onDuplicate();
        }
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }

    private onCloseRechargeModal(eventData: any) {
        this.isRecharge = !eventData.close || false;
    }

    private async onAcceptRechargeModal(eventData: any) {
        this.isRecharge = !eventData.close || false;
        if (eventData.data) {
            const rechargeModel = eventData.data;
            const dataRequest = {
                Amount: numeral(rechargeModel.rechargeValue).value(),
                Method: rechargeModel.bankId,
                UID: this.userInfo.userId,
                Username: this.userInfo.userName,
                TradeContent: rechargeModel.tradeContent,
                OrderIDs: this.order.id.toString()
            };

            const result = await creditServices.submitRecharge(dataRequest);

            if (result && result.status === 200 && result.data.message === 'Success') {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Tạo lệnh nạp tiền thành công!',
                });
                eventBus.$emit(APP_CONFIG.eventBusAction.reloadWithdrawalHistories);
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Tạo lệnh nạp tiền thất bại!',
                });
            }
        }
    }
}
